export class Event {
    constructor(type, params) {
        this.type = type;
        this.params = params || null;
    }
    getParams() {
        return this.params;
    }
    getType() {
        return this.type;
    }
}
Event.MATCH = "match";
Event.MISMATCH = "mismatch";
Event.REMATCH = "rematch";
Event.NO_REMATCH = "no rematch";
Event.NOT_ADJACENT_ORBS_SELECTED = "not adjacent orbs selected";
Event.RESHUFFLE = "reshuffle";
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRXZlbnQuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvbGliL2V2ZW50cy9FdmVudC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxNQUFNLE9BQU8sS0FBSztJQVlkLFlBQVksSUFBWSxFQUFFLE1BQVk7UUFFbEMsSUFBSSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUM7UUFDakIsSUFBSSxDQUFDLE1BQU0sR0FBRyxNQUFNLElBQUksSUFBSSxDQUFDO0lBQ2pDLENBQUM7SUFFTSxTQUFTO1FBRVosT0FBTyxJQUFJLENBQUMsTUFBTSxDQUFDO0lBQ3ZCLENBQUM7SUFFTSxPQUFPO1FBRVYsT0FBTyxJQUFJLENBQUMsSUFBSSxDQUFDO0lBQ3JCLENBQUM7O0FBeEJzQixXQUFLLEdBQUcsT0FBTyxDQUFDO0FBQ2hCLGNBQVEsR0FBRyxVQUFVLENBQUM7QUFDdEIsYUFBTyxHQUFHLFNBQVMsQ0FBQztBQUNwQixnQkFBVSxHQUFJLFlBQVksQ0FBQztBQUMzQixnQ0FBMEIsR0FBRyw0QkFBNEIsQ0FBQztBQUMxRCxlQUFTLEdBQUcsV0FBVyxDQUFDIn0=